<template>
  <div>
    <div
      class="pw-player-button"
      @click="togglePlay"
      v-html="playbtnString.value"
    ></div>
    <div
      class="pw-player-button"
      @mouseenter="showVolume"
      @mouseleave="offVolumeHover"
      @click="isMuted = !isMuted"
      v-if="!IS_IOS"
      v-html="volumeBtnSvg"
    ></div>
    <div
      class="volumeScroller hide"
      ref="volumeBar"
      @mouseenter="showVolume"
      @mouseleave="offVolumeHover"
    >
      <input
        type="range"
        ref="volumeSeeker"
        min="0"
        max="1"
        step="0.01"
        :style="volumecss"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { ComputedRef, defineComponent, PropType, ref, Ref } from "vue"
import replaceClass from "@/services/replaceClass"
import setUpVolume from "@/composables/shared/volume-handler"
export default defineComponent({
  props: {
    IS_IOS: { type: Boolean, required: false, default: false },
    togglePlay: { type: Function, required: true },
    playbtnString: {
      type: Object as PropType<ComputedRef<String>>,
      required: true
    },
    mediaElm: {
      type: Object as PropType<Ref<HTMLMediaElement>>,
      required: true
    }
  },
  setup(props) {
    let volumeBar = ref<HTMLElement>()
    let volumeSeekTimer = 0
    let volumeSeeker = ref<HTMLInputElement>()
    let { isMuted, volume, volumecss, volumeBtnSvg } = setUpVolume(
      props.mediaElm
    )
    return {
      volumeSeekTimer,
      volumeBar,
      volumeSeeker,
      isMuted,
      volume,
      volumecss,
      volumeBtnSvg
    }
  },
  mounted() {
    this.volumeSeekerSetUp()
  },
  methods: {
    volumeSeekerSetUp() {
      if (!this.volumeSeeker) return //TODO throw or log error
      var self = this
      this.volumeSeeker.oninput = function () {
        var value: number = parseFloat(self.volumeSeeker?.value ?? "0")
        self.volume = value
        if (value == 0) self.isMuted = true
        else self.isMuted = false
      }
    },
    onVolumeHover() {
      clearTimeout(this.volumeSeekTimer)
    },
    offVolumeHover() {
      this.volumeSeekTimer = setTimeout(this.hideVolume, 200)
    },
    hideVolume() {
      clearTimeout(this.volumeSeekTimer)
      replaceClass(this.volumeBar as HTMLElement, `show`, `hide`)
    },
    showVolume() {
      clearTimeout(this.volumeSeekTimer)
      replaceClass(this.volumeBar as HTMLElement, `hide`, `show`)
    }
  }
})
</script>
